var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import Component from 'vue-class-component';
import HeaderItem from "../../../components/HeaderItem";
import { Prop, Watch } from 'vue-property-decorator';
import CommonService from "../../../api/CommonService";
import EHanldeStatus from '../../../enum/EHandleStatus';
import { Loading } from 'element-ui';
import _ from 'lodash';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.EHanldeStatus = EHanldeStatus;
        _this.orderStatusList = [];
        _this.accountOptions = [];
        _this.organBusiness = [];
        _this.receiveDepotList = [];
        _this.outOrganList = [];
        _this.orderStatus_retailSales = 2;
        _this.pickerOptions = {};
        _this.appointmentDeliveryTimepickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now() - 86400000;
            }
        };
        _this.deliveryPickerOptions = {};
        _this.originalValues = {
            deliverer_id: null,
            deliverer_phone: '',
            delivery_plate_number: '',
            logistics_number: ''
        };
        _this.oldValue = '';
        return _this;
    }
    default_1.prototype.watchOrderType = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue == this.orderStatus_retailSales) {
            this.getShop({ type: 2, freeze: 0 });
            this.formData.business_id = 0;
            this.formData.shop_id = null;
        }
        else {
            this.getShop({ type: 1, freeze: 0 });
            this.formData.business_id = '';
            this.formData.shop_id = null;
        }
    };
    default_1.prototype.watchOrganBusiness = function (newValue, oldValue) {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue) {
            this.organBusiness.forEach(function (item, index) {
                item.children.forEach(function (items, index) {
                    if (items.id == newValue) {
                        _this.formData.reciever_address = items.shop_address;
                    }
                });
            });
            if (!this.organBusiness || !this.organBusiness.length) {
                this.receiveDepotList = [];
                this.outOrganList = [];
                this.formData.organ_id = '';
                return;
            }
            for (var i = 0; i < this.organBusiness.length; i++) {
                var data = this.organBusiness[i];
                for (var j = 0; j < data.children.length; j++) {
                    if (data.children[j].id == newValue) {
                        this.formData.business_id = data.id;
                        this.formData.supplier_to_business_id = data.supplier_to_business_id;
                        this.getReceiveDepotList({
                            business_id: data.id,
                            supplier_to_business_id: data.supplier_to_business_id,
                            shop_id: newValue,
                        });
                        this.formData.organ_id = '';
                        this.getOrganList({
                            business_id: data.id,
                            supplier_to_business_id: data.supplier_to_business_id
                        }, true);
                        return;
                    }
                }
            }
        }
        else {
            this.receiveDepotList = [];
            this.outOrganList = [];
            this.formData.organ_id = '';
            this.formData.reciever_phone = '';
            return;
        }
    };
    default_1.prototype.watchorgan_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue) {
            this.getOrganDepot({
                organ_id: newValue
            });
        }
        else {
            this.otherData.outStoreList = [];
            this.formData.out_depot_id = '';
            return;
        }
    };
    default_1.prototype.watchdepot_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        var depotItem = this.receiveDepotList.filter(function (item) {
            return item.depot_id == newValue;
        });
        this.formData.depot_name = depotItem.depot_name;
    };
    default_1.prototype.watchPooLastTime = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Add)
            return;
        if (newValue) {
            this.deliveryPickerOptions = {
                disabledDate: function (time) {
                    return time.getTime() < new Date(newValue).getTime() - 86400 * 1000;
                }
            };
        }
    };
    default_1.prototype.watchLogistic = function (newValue, oldValue) {
        this.formData.logistics_number = newValue.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5、]/g, "");
    };
    default_1.prototype.watchOldValue = function (newValue, oldValue) {
        this.oldValue = oldValue;
    };
    default_1.prototype.watchAppointmentDeliveryTime = function (newValue) {
        var _this = this;
        var appointment_delivery_time = new Date(newValue).format('yyyy-MM-dd hh:mm');
        console.log(123333, newValue, this.oldValue);
        var is_change = false;
        var goods_list = _.cloneDeep(this.activeTab === 'goods' ? this.goodList : this.shopList.map(function (item) { return item.items; }).flat());
        var base_goods_list = _.cloneDeep(this.activeTab === 'goods' ? this.baseGoodList : this.baseShopList.map(function (item) { return item.items; }).flat());
        base_goods_list = _.keyBy(base_goods_list, 'order_detail_id');
        for (var i in goods_list) {
            var order_detail_id = goods_list[i].order_detail_id;
            var base_goods = base_goods_list[order_detail_id] || {};
            console.log(123456, goods_list[i].order_detail_oamount, base_goods.order_detail_oamount, goods_list[i].order_gift_oamount, base_goods.order_gift_oamount);
            if (!base_goods) {
                is_change = true;
                break;
            }
            if (goods_list[i].order_detail_oamount != base_goods.order_detail_oamount ||
                goods_list[i].order_gift_oamount != base_goods.order_gift_oamount) {
                is_change = true;
                console.log(33333, is_change);
                break;
            }
        }
        if (is_change) {
            console.log(11111, is_change);
            this.$confirm('该单据送货数量已修改，是否以修改后的数量进行预约？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(function (confirm_res) {
                _this.$emit('save', {
                    status: 0, callback: function () { return _this.saveAppointmentDeliveryTime(appointment_delivery_time); }
                });
                return;
            }).catch(function (err) {
            });
            return;
        }
        console.log(222222, is_change);
        this.saveAppointmentDeliveryTime(appointment_delivery_time);
    };
    default_1.prototype.saveAppointmentDeliveryTime = function (appointment_delivery_time, check) {
        var _this = this;
        if (check === void 0) { check = 1; }
        var param = {
            delivery_order_ids: this.orderId,
            appointment_delivery_time: appointment_delivery_time,
            check: check,
            deliverer_id: this.formData.deliverer_id,
            deliverer: this.getDelivererName(),
            deliverer_phone: this.formData.deliverer_phone,
            delivery_plate_number: this.formData.delivery_plate_number,
            logistics_number: this.formData.logistics_number,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.commonService.sendAppointmentDeliveryTime(param).then(function (res) {
            loadingInstance.close();
            if (res.data.code != 0) {
                var text = '';
                if (res.data.code == 1) {
                    text = '客户该时间段支持配送！是否预约该时间进行配送？';
                }
                else if (res.data.code == 2) {
                    var time = _this.getTimeHM(appointment_delivery_time);
                    var time_range_text = _this.calculateHalfHourInterval(time);
                    text = "\u5BA2\u6237\u8BE5\u65F6\u95F4\u6BB5\uFF08" + time_range_text + "\uFF09\u4E0D\u652F\u6301\u914D\u9001\u3002\u8BF7\u9009\u62E9\u5176\u4ED6\u65F6\u95F4\u70B9\u8FDB\u884C\u914D\u9001\u3002";
                }
                else if (res.data.code == 3) {
                    text = "\u8BE5\u65F6\u95F4\u6BB5\u5DF2\u88AB\u5176\u4ED6\u4F9B\u5E94\u5546\u9009\u62E9\uFF0C\u8BF7\u91CD\u65B0\u9884\u7EA6\u3002";
                }
                else {
                    _this.formData.appointment_delivery_time = _this.oldValue;
                    console.log(123123, _this.formData.appointment_delivery_time);
                    _this.$message.error(res.data.msg);
                    return;
                }
                _this.$confirm(text, '提示', {
                    confirmButtonText: '确定',
                }).then(function (confirm_res) {
                    console.log(33333, res);
                    if (res.data.code == 1) {
                        _this.saveAppointmentDeliveryTime(appointment_delivery_time, 0);
                    }
                    else {
                        _this.formData.appointment_delivery_time = _this.oldValue;
                    }
                }).catch(function (err) {
                    console.log(44444, res.data.code);
                    _this.formData.appointment_delivery_time = _this.oldValue;
                });
            }
            else {
                _this.$message.success(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getTimeHM = function (time) {
        var dateTime = new Date(time);
        var h = dateTime.getHours().toString().padStart(2, '0');
        var m = dateTime.getMinutes().toString().padStart(2, '0');
        return h + ":" + m;
    };
    default_1.prototype.calculateHalfHourInterval = function (time) {
        var inputTime = new Date("1970-01-01T" + time);
        var minutes = inputTime.getMinutes();
        var halfHourStart = new Date(inputTime);
        halfHourStart.setMinutes(minutes < 30 ? 0 : 30);
        var halfHourEnd = new Date(halfHourStart);
        halfHourEnd.setMinutes(halfHourStart.getMinutes() + 30);
        var formattedStartTime = halfHourStart.getHours() + ":" + halfHourStart.getMinutes().toString().padStart(2, '0');
        var formattedEndTime = halfHourEnd.getHours() + ":" + halfHourEnd.getMinutes().toString().padStart(2, '0');
        return formattedStartTime + " \uFF5E " + formattedEndTime;
    };
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.getOrderStatusList();
        this.getAccountOptions();
        var myDate = new Date();
        this.formData.delivery_time = myDate;
        if (this.handleStatus === EHanldeStatus.Add) {
            this.getShop({ type: 1, freeze: 0 });
            if (myDate.getHours() < 13) {
                this.formData.expect_arrivedate = myDate;
            }
            else {
                this.formData.expect_arrivedate = new Date(myDate.getTime() + 3600 * 1000 * 24);
            }
        }
        else {
            this.getOrganList({ business_id: this.formData.business_id, supplier_to_business_id: this.formData.supplier_to_business_id });
        }
    };
    default_1.prototype.mounted = function () {
        this.saveOriginalValues();
    };
    default_1.prototype.saveOriginalValues = function () {
        this.originalValues.deliverer_id = this.formData.deliverer_id;
        this.originalValues.deliverer_phone = this.formData.deliverer_phone;
        this.originalValues.delivery_plate_number = this.formData.delivery_plate_number;
        this.originalValues.logistics_number = this.formData.logistics_number;
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    default_1.prototype.shopSelect = function (node) {
        this.formData.reciever_phone = node.shop_phone;
    };
    default_1.prototype.onDelivererChange = function (delivererId) {
        if (delivererId) {
            var selectedDeliverer = this.accountOptions.find(function (item) { return item.account_id === delivererId; });
            if (selectedDeliverer && selectedDeliverer.mobile) {
                this.formData.deliverer_phone = selectedDeliverer.mobile;
            }
        }
        else {
            this.formData.deliverer_phone = '';
        }
        this.checkAndSyncDeliveryInfo('deliverer_id');
    };
    default_1.prototype.getDelivererName = function () {
        var _this = this;
        if (!this.formData.deliverer_id) {
            return '';
        }
        var selectedDeliverer = this.accountOptions.find(function (item) { return item.account_id === _this.formData.deliverer_id; });
        return selectedDeliverer ? selectedDeliverer.name : '';
    };
    default_1.prototype.onDelivererBlur = function () {
    };
    default_1.prototype.onDelivererPhoneBlur = function () {
        this.checkAndSyncDeliveryInfo('deliverer_phone');
    };
    default_1.prototype.onDeliveryPlateNumberBlur = function () {
        this.checkAndSyncDeliveryInfo('delivery_plate_number');
    };
    default_1.prototype.onLogisticsNumberBlur = function () {
        this.checkAndSyncDeliveryInfo('logistics_number');
    };
    default_1.prototype.checkAndSyncDeliveryInfo = function (fieldName) {
        if (this.formData.is_open_appointment_delivery_time != 1 || !this.formData.appointment_delivery_time) {
            return;
        }
        var currentValue = this.formData[fieldName];
        var originalValue = this.originalValues[fieldName];
        if (currentValue === originalValue) {
            return;
        }
        this.originalValues[fieldName] = currentValue;
        var appointment_delivery_time = new Date(this.formData.appointment_delivery_time).format('yyyy-MM-dd hh:mm');
        this.syncDeliveryInfoToBackend(appointment_delivery_time);
    };
    default_1.prototype.syncDeliveryInfoToBackend = function (appointment_delivery_time) {
        var _this = this;
        this.$nextTick(function () {
            var param = {
                delivery_order_ids: _this.orderId,
                appointment_delivery_time: appointment_delivery_time,
                check: 0,
                deliverer_id: _this.formData.deliverer_id,
                deliverer: _this.getDelivererName(),
                deliverer_phone: _this.formData.deliverer_phone,
                delivery_plate_number: _this.formData.delivery_plate_number,
                logistics_number: _this.formData.logistics_number,
            };
            _this.commonService.sendAppointmentDeliveryTime(param).then(function (res) {
                if (res.data.code != 0) {
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                _this.$message.error(err.message || err.msg);
            });
        });
    };
    default_1.prototype.organChange = function (value) {
        this.$emit('organChange', value);
    };
    default_1.prototype.getOrganDepot = function (data) {
        var _this = this;
        this.commonService.getDepotList({
            is_init: 1,
            organ_id: data.organ_id
        }).then(function (res) {
            _this.otherData.outStoreList = res.data.data || [];
            _this.formData.out_depot_id = '';
            if (_this.otherData.outStoreList.length) {
                _this.formData.out_depot_id = _this.otherData.outStoreList[0].depot_id;
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getOrderStatusList = function () {
        this.orderStatusList = [{
                value: 1,
                name: '无单送货'
            }, {
                value: 2,
                name: '散客销售'
            }];
    };
    default_1.prototype.getOrganList = function (data, flag) {
        var _this = this;
        if (flag === void 0) { flag = false; }
        var params = {
            business_id: data.business_id,
            supplier_to_business_id: data.supplier_to_business_id
        };
        return this.commonService.getOrganList(params).then(function (res) {
            var data = res.data.data;
            _this.outOrganList = data || [];
            if (_this.outOrganList.length) {
                if (!_this.formData.organ_id)
                    _this.formData.organ_id = _this.outOrganList[0].organ_id;
                if (_this.formData.organ_id && flag) {
                    _this.$emit('updateOcrGoodInfo');
                }
            }
            else {
                _this.$message.warning('请先将客户与分支机构绑定后再新增送货单');
            }
        });
    };
    default_1.prototype.getShop = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = res.data.data || [];
                if (params.type == 2 && depot.length) {
                    _this.formData.business_id = depot[0].id;
                    _this.formData.shop_id = depot[0].children[0].id;
                }
                _this.organBusiness = depot;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getReceiveDepotList = function (data) {
        var _this = this;
        var params = {
            supplier_to_business_id: data.supplier_to_business_id,
            business_id: data.business_id,
            shop_id: data.shop_id,
        };
        this.commonService.getReceiveDepotList(params).then(function (res) {
            _this.receiveDepotList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getAccountOptions = function () {
        var _this = this;
        this.commonService.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "orderId", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "otherData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "goodList", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "shopList", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "baseGoodList", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "baseShopList", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "activeTab", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch("formData.order_type")
    ], default_1.prototype, "watchOrderType", null);
    __decorate([
        Watch("formData.shop_id")
    ], default_1.prototype, "watchOrganBusiness", null);
    __decorate([
        Watch("formData.organ_id")
    ], default_1.prototype, "watchorgan_id", null);
    __decorate([
        Watch("formData.depot_id")
    ], default_1.prototype, "watchdepot_id", null);
    __decorate([
        Watch("formData.poo_last_ctime")
    ], default_1.prototype, "watchPooLastTime", null);
    __decorate([
        Watch('formData.logistics_number')
    ], default_1.prototype, "watchLogistic", null);
    __decorate([
        Watch('formData.appointment_delivery_time')
    ], default_1.prototype, "watchOldValue", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData'
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
